import React from 'react';
import PropTypes from 'prop-types';

const ServiceDescription = ({ description }) => (
  <div
    className="services-import__list-service-description"
    style={{ maxHeight: '300px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}
  >
    {description}
  </div>
);

ServiceDescription.propTypes = {
  description: PropTypes.string,
};

export default ServiceDescription;
